import { render } from "./KeyIcon.vue?vue&type=template&id=51f9887a&scoped=true"
import script from "./KeyIcon.vue?vue&type=script&lang=js"
export * from "./KeyIcon.vue?vue&type=script&lang=js"

import "./KeyIcon.vue?vue&type=style&index=0&id=51f9887a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51f9887a"

export default script